import React from 'react';
import { User } from 'lucide-react';

/**
 * Top-of-form patient identity strip — first/last name + patient_code + DOB.
 * Used on subjective, objective, treatment plan, chart, follow-up pages so the
 * clinician always sees who they're documenting on.
 */
export default function PatientIdentityHeader({ patient, suffix }) {
  if (!patient) return null;
  return (
    <div className="surface border border-soft rounded-lg p-3 mb-4 flex items-center gap-4 print:rounded-none print:border-x-0" data-testid="patient-identity-header">
      <div className="w-10 h-10 rounded-full bg-brand/10 flex items-center justify-center text-brand shrink-0">
        {patient.photo_url
          ? <img src={patient.photo_url} alt="" className="w-10 h-10 rounded-full object-cover"/>
          : <User className="w-5 h-5"/>}
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-heading font-semibold text-sm md:text-base truncate" data-testid="pih-name">
          {patient.full_name || '—'}
        </div>
        <div className="text-[11px] text-fg-muted truncate">
          {patient.patient_code && (
            <span className="font-mono mr-3" data-testid="pih-code">ID · {patient.patient_code}</span>
          )}
          {patient.date_of_birth && <span className="mr-3">DOB {patient.date_of_birth}</span>}
          {patient.country && <span className="mr-3">{patient.country}</span>}
          {patient.phone && <span className="mr-3">{patient.phone}</span>}
          {patient.email && <span className="truncate">{patient.email}</span>}
        </div>
      </div>
      {suffix && <div className="shrink-0 text-xs text-fg-muted">{suffix}</div>}
    </div>
  );
}
